import type { PaymentsMessageId } from "./payments.fr";

/** Paiements in European Portuguese. Same keys and {placeholders} as payments.fr.ts. */
export const paymentsPt: Record<PaymentsMessageId, string> = {
  "payments.tab.payments": "Pagamentos",
  "payments.tab.approvals": "Pedidos de aprovação",
  "payments.pick": "Escolha um pagamento na lista.",
  "payments.loading": "A carregar o pagamento…",
  "payments.loadFailed": "Não foi possível carregar este pagamento.",
  "payments.notFound": "Este pagamento não foi encontrado. Recarregue a lista.",
  "payments.refreshFailed": "Não foi possível atualizar o pagamento: é mostrado tal como estava.",

  "payments.filter.provider": "Meio de pagamento",
  "payments.filter.status": "Estado",
  "payments.filter.all": "Todos",
  "payments.filter.from": "De",
  "payments.filter.to": "Até",
  "payments.filter.duplicates": "Prováveis duplicados",
  "payments.filter.clearPro": "Todos os profissionais",
  "payments.list.loading": "A carregar os pagamentos…",
  "payments.list.loadFailed": "Não foi possível carregar os pagamentos.",
  "payments.list.empty": "Nenhum pagamento para estes filtros.",
  "payments.list.aria": "Pagamentos de taxas",
  "payments.list.end": "Fim da lista",
  "payments.pill.duplicate": "Provável duplicado",

  "payments.status.pending": "Por pagar",
  "payments.status.paid": "Pago",
  "payments.status.failed": "Falhado",
  "payments.status.refunded": "Reembolsado",
  "payments.status.waived": "Taxa anulada",
  "payments.provider.orange_money": "Orange Money",
  "payments.provider.lengo_pay": "Mobile Money",
  "payments.provider.stripe": "Cartão (Stripe)",
  "payments.provider.wave": "Wave",
  "payments.feeType.per_job": "Taxa de contacto",
  "payments.feeType.monthly": "Assinatura mensal",
  "payments.feeType.yearly": "Assinatura anual",
  "payments.kind.refund": "Reembolso",
  "payments.kind.credit": "Crédito",
  "payments.kind.waive": "Anulação da taxa",
  "payments.kind.mark_paid": "Marcado como pago",

  "payments.detail.versionTitle": "A versão do pagamento mostrada: cada correção envia-a.",
  "payments.detail.duplicate": "Provável duplicado",
  "payments.detail.duplicateBody":
    "Outro pagamento do mesmo profissional, do mesmo montante, alguns minutos antes ou depois. Verifique antes de reembolsar:",
  "payments.detail.pro": "Profissional",
  "payments.detail.proPayments": "Pagamentos deste profissional →",
  "payments.detail.transaction": "Referência no fornecedor",
  "payments.detail.job": "Pedido",
  "payments.detail.refunded": "Já reembolsado",
  "payments.detail.refundable": "Ainda reembolsável",
  "payments.detail.credit": "Crédito do profissional",
  "payments.detail.adjustments": "Correções",
  "payments.detail.noAdjustments": "Nenhuma correção neste pagamento.",
  "payments.detail.actions": "Corrigir",
  "payments.detail.neverOptimistic":
    "Nada é mostrado como feito antes da resposta do servidor. Um reembolso sem resposta do fornecedor nunca é reenviado.",
  "payments.col.kind": "Correção",
  "payments.col.amount": "Montante",
  "payments.col.status": "Situação",
  "payments.col.by": "Por",
  "payments.col.actions": "Ações",

  "payments.adjustment.status.pending": "Estado desconhecido, verificação em curso",
  "payments.adjustment.status.done": "Feito",
  "payments.adjustment.status.failed": "Recusado pelo fornecedor",
  "payments.adjustment.status.awaiting_manual_transfer": "Transferência manual por fazer",
  "payments.adjustment.status.awaiting_approval": "A aguardar aprovação",
  "payments.adjustment.status.rejected": "Recusado pelo proprietário",
  "payments.adjustment.outcomeUnknownHint":
    "Enviado ao fornecedor sem resposta. Nunca é reenviado: verifique no painel do fornecedor e depois liquide-o.",
  "payments.adjustment.manualHint":
    "A Orange Money não tem reembolso automático: envie o dinheiro manualmente e depois liquide com a referência da transferência.",

  "payments.action.refund": "Reembolsar",
  "payments.action.credit": "Creditar",
  "payments.action.waive": "Anular a taxa",
  "payments.action.markPaid": "Marcar como pago",
  "payments.action.settle": "Liquidar",
  "payments.action.approve": "Aprovar",
  "payments.action.reject": "Recusar",

  "payments.dialog.refund.title": "Reembolsar · {subject}",
  "payments.dialog.refund.body":
    "O reembolso é registado e depois enviado uma única vez ao fornecedor. Acima do limite, aguarda a aprovação de um proprietário.",
  "payments.dialog.credit.title": "Creditar · {subject}",
  "payments.dialog.credit.body": "Um saldo descontado das próximas taxas do profissional, na mesma moeda.",
  "payments.dialog.waive.title": "Anular a taxa · {subject}",
  "payments.dialog.waive.body":
    "A taxa deixa de ser devida. Acima do limite, a anulação aguarda a aprovação de um proprietário.",
  "payments.dialog.markPaid.title": "Marcar como pago · {subject}",
  "payments.dialog.markPaid.body":
    "Apenas com a referência do pagamento real (o SMS do profissional ou o extrato). Uma referência marca um único pagamento.",
  "payments.dialog.settle.title": "Liquidar o reembolso · {subject}",
  "payments.dialog.settle.body": "Registe como terminou o reembolso, depois de verificado no fornecedor.",
  "payments.dialog.approve.title": "Aprovar o pedido de {subject}",
  "payments.dialog.approve.body": "A correção pedida aplica-se a partir de agora. Ninguém aprova o próprio pedido.",
  "payments.dialog.reject.title": "Recusar o pedido de {subject}",
  "payments.dialog.reject.body": "Nada é reembolsado nem anulado. O motivo fica guardado com o pedido.",
  "payments.field.amount": "Montante ({currency})",
  "payments.field.refundHint": "Deixe em branco para reembolsar tudo: {amount}.",
  "payments.field.orangeMoneyReference": "Referência da transação Orange Money",
  "payments.field.reference": "Referência no fornecedor",
  "payments.field.referenceHint": "Copie-a por inteiro do SMS ou do extrato: letras, algarismos e . _ : / -",
  "payments.field.outcome": "Resultado",
  "payments.field.outcome.done": "O dinheiro foi enviado",
  "payments.field.outcome.failed": "O reembolso falhou",

  "payments.problem.reason": "Indique um motivo com pelo menos {min} caracteres.",
  "payments.problem.amount": "Introduza um montante superior a zero, com no máximo duas casas decimais.",
  "payments.problem.tooMuch": "É mais do que o que ainda é reembolsável.",
  "payments.problem.reference":
    "Copie a referência por inteiro: pelo menos {min} caracteres, apenas letras, algarismos e . _ : / -.",

  "payments.outcome.done": "{kind} de {amount}: feito.",
  "payments.outcome.pending":
    "{kind} de {amount}: estado desconhecido, verificação em curso. Não será reenviado; liquide-o depois de verificado.",
  "payments.outcome.awaiting_manual_transfer":
    "{kind} de {amount} registado: envie o dinheiro manualmente e depois liquide-o com a referência.",
  "payments.outcome.awaiting_approval": "{kind} de {amount}: além do que pode fazer sozinho, aguarda uma aprovação.",
  "payments.outcome.failed": "{kind} de {amount} recusado pelo fornecedor ({failure}). Nada mudou.",
  "payments.outcome.rejected": "{kind} de {amount} recusado.",

  "payments.approvals.status.pending": "Pendentes",
  "payments.approvals.status.approved": "Aprovados",
  "payments.approvals.status.rejected": "Recusados",
  "payments.approvals.loading": "A carregar os pedidos…",
  "payments.approvals.loadFailed": "Não foi possível carregar os pedidos de aprovação.",
  "payments.approvals.empty": "Nenhum pedido aqui.",
  "payments.approvals.requested": "Pedido por {name} a {date}",
  "payments.approvals.permission": "Permissão: {permission}",
  "payments.approvals.theirLimit": "O seu limite: {amount}",
  "payments.approvals.noPermission": "Esta pessoa não tem esta permissão.",
  "payments.approvals.noLimitInCurrency": "Esta pessoa não tem limite nesta moeda.",
  "payments.approvals.openPro": "Abrir o profissional →",
  "payments.approvals.decided": "Decidido por {name} a {date}",
  "payments.approvals.openPayment": "Abrir o pagamento →",
  "payments.approvals.own": "Este pedido é seu: outro proprietário tem de o decidir.",

  "payments.export.month": "Mês a exportar",
  "payments.export.reason": "Motivo (opcional)",
  "payments.export.button": "Exportar o CSV",
  "payments.export.running": "A exportar…",
  "payments.export.hint":
    "Os pagamentos do mês (UTC) para a reconciliação, sem telefone nem email. Cada exportação fica registada no registo de auditoria.",
  "payments.export.done": "Exportação descarregada. Fica registada no registo de auditoria.",

  "payments.error.stale": "Este pagamento mudou enquanto o consultava. Recarregue-o, verifique e tente novamente.",
  "payments.error.refused":
    "Correção recusada: as suas funções não incluem a funcionalidade necessária. Peça acesso a um responsável.",
  "payments.error.approvalRefused":
    "Recusado: só um proprietário com APPROVE_PAYMENT_REQUESTS pode decidir, e nunca o próprio pedido.",
  "payments.error.invalid":
    "Recusado: o pagamento já não está no estado esperado, o montante excede o que resta, ou a referência já foi usada. Recarregue e verifique.",
  "payments.error.outcomeUnknown":
    "Sem resposta do servidor: a correção pode ter sido registada. Tente novamente: o mesmo clique não pode ser aplicado duas vezes.",

  "payments.refused.notRefundable": "Recusado: só uma taxa paga pode ser reembolsada. Recarregue o pagamento.",
  "payments.refused.nothingToRefund":
    "Recusado: esta taxa já foi reembolsada na totalidade, ou o resto está pendente. Recarregue o pagamento.",
  "payments.refused.refundTooLarge": "Recusado: o montante excede o que resta reembolsar nesta taxa.",
  "payments.refused.alreadyAwaitingApproval":
    "Recusado: uma isenção desta taxa já aguarda um proprietário. Recarregue o pagamento.",
  "payments.refused.notMarkable":
    "Recusado: só uma taxa pendente ou falhada pode ser marcada como paga. Recarregue o pagamento.",
  "payments.refused.referenceInUse":
    "Recusado: esta referência Orange Money já pagou outra taxa. Verifique a referência.",
  "payments.refused.referenceRequired": "Introduza a referência da transação.",
  "payments.refused.alreadySettled": "Este reembolso acabou de ser liquidado. Recarregue-o.",
  "payments.refused.alreadyDecided": "Este pedido acabou de ser decidido. Recarregue a lista.",
  "payments.refused.ownRequest": "Recusado: fez este pedido, por isso outro proprietário decide.",
  "payments.refused.approverNotPermitted":
    "Não tem esta permissão para este montante, por isso não pode decidir. Outra pessoa decide.",
  "payments.refused.paymentChanged":
    "Recusado: o pagamento mudou desde o pedido. Rejeite-o em vez disso, com o motivo.",
  "payments.refused.currencyMismatch": "Recusado: o crédito tem de ser na moeda da taxa.",
  "payments.refused.feeOfAnotherPro": "Recusado: esta taxa foi paga por outro profissional.",
  "payments.refused.invalidAmount": "Recusado: o montante tem de ser superior a zero.",
};
